export const isStandalone = () => {
  return window.matchMedia('(display-mode: standalone)').matches;
};
